// Single source of truth for admin email addresses.
// Update here only — all files import from this location.
export const ADMIN_EMAILS = ['blisssly94@gmail.com']
